// Shared CRM constants & helpers — kept in a standalone module to avoid
// circular imports between CRMPro, KanbanBoard, LeadDetailDrawer and the widget.

export const SOURCE_OPTIONS = [
  { value: '', label: 'सभी Sources' },
  { value: 'landing_page', label: '🌐 Landing' },
  { value: 'aayush_chat', label: '🤖 Aayush AI' },
  { value: 'whatsapp_bot', label: '💬 WhatsApp Bot' },
  { value: 'fb_ad', label: '📣 FB Ad' },
  { value: 'manual', label: '✍️ Manual' },
];

export const STATUS_OPTIONS = [
  { value: 'new', label: '🆕 New', color: 'bg-blue-100 text-blue-700' },
  { value: 'contacted', label: '📞 Contacted', color: 'bg-yellow-100 text-yellow-700' },
  { value: 'nurturing', label: '💬 Nurturing', color: 'bg-purple-100 text-purple-700' },
  { value: 'demo_scheduled', label: '📅 Demo Scheduled', color: 'bg-orange-100 text-orange-700' },
  { value: 'demo_done', label: '✅ Demo Done', color: 'bg-indigo-100 text-indigo-700' },
  { value: 'conversion_journey', label: '🚀 Conversion Journey', color: 'bg-teal-100 text-teal-700' },
  { value: 'negotiating', label: '🤝 Negotiating', color: 'bg-pink-100 text-pink-700' },
  { value: 'closed_won', label: '🎉 Closed Won', color: 'bg-green-100 text-green-700' },
  { value: 'closed_lost', label: '❌ Closed Lost', color: 'bg-red-100 text-red-700' },
  { value: 'upgrade_target', label: '⬆️ Upgrade', color: 'bg-amber-100 text-amber-700' },
];

// The 4 ordered sub-stages shown inside the Conversion Journey column.
export const JOURNEY_STAGES = [
  { key: 'demo', label: '🎬 Demo हो गया' },
  { key: 'data', label: '📤 Data Upload' },
  { key: 'payment_link', label: '💳 Payment Link' },
  { key: 'subscribed', label: '✅ Subscribed' },
];

// Engagement stage of a lead in Aayush's conversation funnel.
export const ENGAGEMENT_META = {
  beginner: { label: '🌱 New / Beginner', cls: 'bg-sky-50 text-sky-700 border border-sky-200' },
  ready: { label: '🎯 Ready (info मिली)', cls: 'bg-violet-50 text-violet-700 border border-violet-200' },
  stalled: { label: '😴 Stalled (3+ दिन)', cls: 'bg-amber-50 text-amber-700 border border-amber-200' },
  demo_sent: { label: '✅ Demo/Trial भेजा', cls: 'bg-emerald-50 text-emerald-700 border border-emerald-200' },
};

export const ENGAGEMENT_OPTIONS = [
  { value: '', label: '🎚️ सभी Engagement' },
  { value: 'beginner', label: '🌱 New / Beginner' },
  { value: 'ready', label: '🎯 Ready (info मिली)' },
  { value: 'stalled', label: '😴 Stalled (re-nurture)' },
  { value: 'demo_sent', label: '✅ Demo/Trial भेजा' },
];

export const statusMeta = (s) => STATUS_OPTIONS.find((o) => o.value === s) || STATUS_OPTIONS[0];
export const sourceLabel = (s) => (SOURCE_OPTIONS.find((o) => o.value === s) || { label: s }).label;
export const inr = (v) => '₹' + Number(v || 0).toLocaleString('en-IN');
